import { app } from '../app.module'
app
  /**
   * @ngdoc LoginCtrl
   * @name LoginCtrl
   * @requires LoginService ログイン機能用のサービス
   * @requires DialogService ダイアログ表示用のサービス
   * @description ログインのメインコントローラー
   */
  .controller('LoginCtrl', function ($scope, LoginService, DialogService) {
    /**
     * login ログイン処理
     * @return {void}
     */
    $scope.login = function () {
      // ログイン処理
      LoginService.login($scope.email, $scope.password).then((result) => {
        //  ログインが成功した場合、ホームページにリダイレクト
        if (result.loginResult === true) {
          let redirectUrl = '/home'
          $scope.authErr = false

          // 通知がある場合はパラメータをセット
          if (result.notificationFlg === 1) {
            redirectUrl += '?notification=' + result.notificationFlg
          }
          // ホームページにリダイレクト
          location.href = redirectUrl
        } else {
          $scope.authErr = true
          //  ログインが失敗した場合、アラートを表示
          const errorTitle = 'ログインに失敗しました。'
          const errorMessage = '正しいメールアドレスとパスワードの組み合わせを入力してください。'

          DialogService.showError(errorTitle, errorMessage)
        }
      })
    }
  })
